import { useState } from "react";
import { IconX } from "../components/ui/Icons";

export default function MobileNav({ open, topTabs, activeTopTab, timelineItems, onClose, onNavigate, onTimelineNavigate }) {
  const [timelineOpen, setTimelineOpen] = useState(false);

  return (
    <>
      <div className={`topOverlay ${open ? "open" : ""}`} onClick={onClose} aria-hidden={!open} />
      <aside className={`topSidebar ${open ? "open" : ""}`} aria-label="Menu boczne" aria-hidden={!open}>
        <div className="topSidebarHeader">
          <div className="topSidebarTitle">Menu</div>
          <button type="button" className="topSidebarClose" onClick={onClose} aria-label="Zamknij menu"><IconX /></button>
        </div>

        <div className="topSidebarList" role="list">
          <button type="button" className={`topSidebarItem ${activeTopTab === "Strona główna" ? "active" : ""}`} onClick={() => { onNavigate("Strona główna"); onClose(); }} role="listitem">Strona główna</button>
          <button type="button" className={`topSidebarItem ${activeTopTab === "Ścieżka czasu" ? "active" : ""}`} onClick={() => setTimelineOpen((value) => !value)} role="listitem" aria-expanded={timelineOpen}>Ścieżka czasu</button>
          {timelineOpen && (
            <div className="sideSubMenu" role="list">
              <button type="button" className="sideSubItem" onClick={() => { onNavigate("Ścieżka czasu"); onClose(); }}>Strona główna osi czasu</button>
              {timelineItems.map((item) => (
                <button
                  key={item.slug}
                  type="button"
                  className="sideSubItem treeChild"
                  onClick={() => { onTimelineNavigate(item.slug); onClose(); }}
                  role="listitem"
                >
                  {item.title}
                </button>
              ))}
            </div>
          )}

          {topTabs.filter((item) => item !== "Ścieżka czasu" && item !== "Strona główna").map((tab) => (
            <button key={tab} type="button" className={`topSidebarItem ${activeTopTab === tab ? "active" : ""}`} onClick={() => { onNavigate(tab); onClose(); }} role="listitem">{tab}</button>
          ))}
        </div>
      </aside>
    </>
  );
}